import instance from "@/services/api";

export const checkListsAPI = {
  async getCheckListsList(params) {
    return await instance()
      .get("/common/check_lists/read/", { params })
      .then((res) => res?.data);
  },
  
  async getWorkSetChecks(params) {
    return await instance()
      .get("/common/work_set_checks/read/", { params })
      .then((res) => res?.data);
  },
  
  async createWorkSetChecks(data) {
    return await instance()
      .post("/common/work_set_checks/create/", data)
      .then((res) => res?.data);
  },
  
  async deleteWorkSetCheck(workSetCheckId) {
    return await instance()
      .delete(`/common/work_set_checks/delete/${workSetCheckId}/`)
      .then((res) => res?.data);
  },
  
  async getWorkSets() {
    return await instance()
      .get("/common/work_sets/read/")
      .then((res) => res?.data);
  },
};
